/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { selectContent } from 'state/actions/embedsState/embedManagementState/content_status';

import { getEmbedEdit } from 'state/actions/embedsState/embedAnalytics';
// component
import ContentAnalyticsCard from 'material/embeds/contentanalyticscard/contentanalyticscard';



/* ========== ~~~~~~~~~~ EMBED : CONTENT ANALYTICS CARD : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ sessionStatus }) => ({
    editPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('manageEmbeds')
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToContentEdit: (contentId) => {
        dispatch(selectContent(contentId));
        dispatch(updatePageDetails('dashboard/embeds/management/customize'));
        dispatch(updateStepDetails('customize'));
        dispatch(changePage(`dashboard/embeds/management/customize`))
    },
    getEmbedEdit: (embedUUID, contentId) => dispatch(getEmbedEdit(embedUUID, contentId))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContentAnalyticsCard);
